import { c as _c } from "react/compiler-runtime";
interface NeurologyIconProps {
  size?: number;
  className?: string;
}
const NeurologyIcon = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M6.54104 13.0013C4.20111 9.44578 6.45672 6.7264 8.31882 6.73343M8.31882 6.73343C8.31882 6.69127 8.31882 6.64208 8.31882 6.59992C8.31882 5.16645 9.59067 4 11.1577 4C12.7246 4 13.9965 5.16645 13.9965 6.59992V6.56479V19.9509C13.9965 20.26 13.9614 20.5622 13.8981 20.8503C13.5397 22.4594 12.2398 23.654 10.6869 23.654C8.85989 23.654 7.37723 21.9957 7.37723 19.9509C7.37723 19.5995 7.41939 19.2622 7.50371 18.946C7.65127 18.3558 7.92532 17.8288 8.29774 17.4001M8.31882 6.73343C8.25558 7.5907 8.67016 9.62848 9.47122 10.1344M5.78917 11.4836C5.46594 11.9895 5.22702 12.5587 5.10054 13.177C4.72109 15.0391 5.38161 17.1893 7.66533 18.4331M17.6996 17.618C18.1845 17.4985 18.9153 16.9996 19.0839 16.4937M8.5226 8.37068C9.01448 8.57446 10.0615 8.33554 10.469 8.04744M21.459 13.0013C23.7989 9.44578 21.5433 6.7264 19.6812 6.73343C19.6812 6.69127 19.6812 6.64208 19.6812 6.59992C19.6812 5.16645 18.4093 4 16.8423 4C15.2754 4 14.0035 5.16645 14.0035 6.59992V6.56479V19.9509C14.0035 20.26 14.0386 20.5622 14.1019 20.8503C14.4603 22.4594 15.7602 23.654 17.3131 23.654C19.1401 23.654 20.6228 21.9957 20.6228 19.9509C20.6228 19.5995 20.5806 19.2622 20.4963 18.946C20.3487 18.3558 18.8731 15.8542 17.9807 15.3694M20.3347 18.4331C22.6184 17.1893 23.2789 15.0391 22.8995 13.177C22.773 12.5657 22.5341 11.9895 22.2108 11.4836M14.4321 11.4836C15.6337 11.2868 16.7651 10.7387 16.8705 9.43173M16.2872 10.6755C16.7369 10.9987 17.3202 11.1252 17.8683 11.0338M14.0035 14.5543C12.7457 14.1537 11.2982 14.4629 11.3825 16.2618C11.4879 17.0769 10.6306 17.358 10.6306 17.358M11.3474 12.9873C10.9679 13.69 11.4879 14.5121 12.2187 14.5543" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== t3 || $[4] !== t5) {
    t7 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}</svg>;
    $[3] = t3;
    $[4] = t5;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  return t7;
};
export default NeurologyIcon;